import { useEffect, useState } from "react";
import "./TermsAndConditionsScreen.css";
import App1e from "../photos/AppEn1.png";
import App2e from "../photos/AppEn2.png";
import App3e from "../photos/AppEn3.png";
import App1r from "../photos/AppRu1.png";
import App2r from "../photos/AppRu2.png";
import App3r from "../photos/AppRu3.png";
import { useT } from "../features/UseT";
import { useSelector } from "react-redux";

function TermsAndConditionsScreen() {
  const images = {
    en: [App1e, App2e, App3e],
    ru: [App1r, App2r, App3r],
  };
  const t = useT();
  const lang = useSelector((s) => s.language.current);
  const [img1, img2, img3] = images[lang] || images.en;

  const [uaHtml, setUaHtml] = useState("");
  useEffect(() => {
    if (!lang) return;
    fetch(`/longtxt/termsandconditions.json`)
      .then((res) => res.json())
      .then((data) => setUaHtml(data.en))
      .catch(console.error);
  }, [lang]);
  return (
    <div className="DeleteScreen">
      <div className="DeleteContainer">
        <a href="/" className="Back">
          <span>{`<< ${t.sdb}`}</span>
        </a>
        <span className="TermsTitle">{t.sdt}</span>
        <div className="StepsContainer">
          <div className="Steps">
            <div className="NumberCircle">
              <span>01</span>
            </div>
            <span
              className="Instruction"
              dangerouslySetInnerHTML={{ __html: t.sds1 }}
            />
            <img src={img1} alt="App1" className="Image" />
          </div>
          <div className="Steps">
            <div className="NumberCircle">
              <span>02</span>
            </div>
            <span
              className="Instruction"
              dangerouslySetInnerHTML={{ __html: t.sds2 }}
            />
            <img src={img2} alt="App1" className="Image" />
          </div>
          <div className="Steps">
            <div className="NumberCircle">
              <span>03</span>
            </div>
            <span
              className="Instruction"
              dangerouslySetInnerHTML={{ __html: t.sds3 }}
            />
            <img src={img3} alt="App1" className="Image" />
          </div>
        </div>
        <span
          className="UserAgreement"
          dangerouslySetInnerHTML={{ __html: uaHtml }}
        />
      </div>
    </div>
  );
}

export default TermsAndConditionsScreen;
